const SvgLogout = () => {
  return (
    <svg
      width="3rem"
      height="3rem"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M17 7L15.59 8.41L18.17 11H8V13H18.17L15.59 15.59L17 17L22 12L17 7Z"
        fill="#fff"
      />
      <path
        d="M19 19H5V5H12V3H5C3.89 3 3 3.9 3 5V19C3 20.1 3.89 21 5 21H19C20.1 21 21 20.1 21 19V13H19V19Z"
        fill="#fff"
      />
    </svg>
  );
};

export default SvgLogout;
